module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "hr"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/line-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', [_vm._v("E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NTERED")]), _vm._v(" according to Act of Congress, in the year 1876, by")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', [_vm._v("F. A. SCHWAB,")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', [_vm._v("In the office of the Librarian of Congress at Washington.")])]), _vm._v(" "), _c('p', {
    staticClass: "hr1"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/line-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "hr2"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/line-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RESS OF")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("YNKOOP")]), _vm._v(" & H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALLENBECK,")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("       113 Fulton Street N.Y.")]), _vm._v(" "), _c('p', {
    staticClass: "hr3"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/line-1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fbeb16a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter2.vue
// module id = 78
// module chunks = 0